(() => {
  function openStudy() {
    const id = window.location.hash.slice(1);
    if (!/^study-0[1-3]$/.test(id)) return;
    const study = document.getElementById(id);
    if (study instanceof HTMLDetailsElement) study.open = true;
  }
  document.addEventListener('DOMContentLoaded', openStudy);
  document.addEventListener('shopify:section:load', openStudy);
  window.addEventListener('hashchange', openStudy);
})();

(() => {
 const films = new Map();
 function initializeFilms(root = document) {
  root.querySelectorAll('[data-brand-film]').forEach(frame => {
   const video = frame.querySelector('video');
   if (!video || films.has(frame)) return;
   const abort = new AbortController(), signal = abort.signal;
   const mobile = matchMedia('(max-width:749px)'), reduced = matchMedia('(prefers-reduced-motion:reduce)');
   const toggle = frame.parentElement?.querySelector('.es-film-toggle');
   let selected = '', attached = '', destroyed = false, visible = true, posterToken = 0, manualPause = false, motionOptIn = false;
   let canvas = null, context = null, glowPoster = null, pendingFrame = null;
   const nativeFrames = typeof video.requestVideoFrameCallback === 'function';
   const posterImage = frame.querySelector('.es-film-poster');
   video.defaultMuted = video.muted = true;
   // F-44: only play() starts the film, so reduced motion and a visitor's pause are never overruled.
   video.autoplay = false; video.loop = video.playsInline = true;
   video.controls = false;
   const motionAllowed = () => !reduced.matches || motionOptIn;
   const mayPlay = () => !destroyed && !manualPause && motionAllowed();
   const updateToggle = () => {
    if (!toggle) return;
    const playing = !video.paused;
    toggle.dataset.playing = String(playing);
    toggle.setAttribute('aria-label', playing ? 'Pause film' : 'Play film');
   };
   const stopBackdrop = () => {
    if (pendingFrame !== null) {
     if (nativeFrames) video.cancelVideoFrameCallback(pendingFrame);
     else cancelAnimationFrame(pendingFrame);
     pendingFrame = null;
    }
   };
   const paintBackdrop = mediaTime => {
    if (!context || destroyed || video.readyState < 2 || !video.videoWidth) return;
    const scale = Math.min(1, 640 / Math.max(video.videoWidth, video.videoHeight));
    const width = Math.max(1, Math.round(video.videoWidth * scale)), height = Math.max(1, Math.round(video.videoHeight * scale));
    if (canvas.width !== width || canvas.height !== height) { canvas.width = width; canvas.height = height; }
    try {
     context.drawImage(video, 0, 0, width, height);
     canvas.dataset.mediaTime = String(mediaTime ?? video.currentTime);
     canvas.classList.add('is-ready');
     frame.dataset.filmBackdrop = 'video';
    } catch { /* Retain the matching blurred poster until a frame can be painted. */ }
   };
   const tickBackdrop = (_now, metadata) => {
    pendingFrame = null;
    if (!canvas || destroyed || document.hidden || !visible) return;
    paintBackdrop(metadata?.mediaTime);
    if (!video.paused && !video.ended) scheduleBackdrop();
   };
   const scheduleBackdrop = () => {
    if (pendingFrame !== null || !canvas || destroyed || document.hidden || !visible || video.paused) return;
    pendingFrame = nativeFrames ? video.requestVideoFrameCallback(tickBackdrop) : requestAnimationFrame(tickBackdrop);
   };
   const removeBackdrop = () => {
    stopBackdrop(); canvas?.remove(); glowPoster?.remove();
    canvas = context = glowPoster = null; delete frame.dataset.filmBackdrop;
   };
   const configureBackdrop = () => {
    if (!canvas) {
     glowPoster = document.createElement('img');
     glowPoster.className = 'es-film-glow-poster'; glowPoster.alt = '';
     glowPoster.setAttribute('aria-hidden', 'true');
     canvas = document.createElement('canvas'); canvas.className = 'es-film-glow';
     canvas.setAttribute('aria-hidden', 'true');
     context = canvas.getContext('2d', { alpha: false });
     frame.prepend(glowPoster, canvas);
    }
    glowPoster.src = video.poster;
    frame.dataset.filmBackdrop = 'poster';
    canvas.classList.remove('is-ready');
   };
   const updateFit = () => {
    frame.style.setProperty('--es-video-fit', 'contain');
    frame.dataset.filmFit = 'contain';
   };
   const reveal = () => {
    if (destroyed) return;
    if (!mayPlay()) { video.pause(); return; }
    video.classList.add('is-playing'); frame.dataset.filmState = 'playing'; updateToggle();
    paintBackdrop(); scheduleBackdrop();
   };
   const play = () => {
    if (!mayPlay() || !video.isConnected || document.hidden || !selected || attached !== selected) return;
    video.muted = true;
    video.play().then(reveal).catch(() => {
     if (!destroyed && video.paused) { video.classList.remove('is-playing'); frame.dataset.filmState = 'poster'; }
    });
   };
   // Start the film only once its cover has loaded, so the two never share a slow phone connection.
   const afterPoster = start => {
    const token = ++posterToken, go = () => { if (token === posterToken && !destroyed) start(); };
    if (!posterImage || posterImage.complete) { go(); return; }
    posterImage.addEventListener('load', go, { once: true, signal });
    posterImage.addEventListener('error', go, { once: true, signal });
   };
   const attach = () => {
    if (destroyed || !selected || attached === selected) return;
    attached = selected; video.src = selected; video.load();
    if (toggle) toggle.hidden = false;
   };
   const select = () => {
    const portrait = mobile.matches && Boolean(video.dataset.videoMobile);
    const src = portrait ? video.dataset.videoMobile : video.dataset.videoDesktop;
    updateFit();
    if (!src) return;
    if (selected === src) { if (!canvas) { configureBackdrop(); paintBackdrop(); scheduleBackdrop(); } return; }
    stopBackdrop(); selected = src; video.pause(); video.classList.remove('is-playing');
    frame.dataset.filmState = 'loading'; frame.dataset.filmVariant = portrait ? 'mobile' : 'desktop';
    video.poster = portrait ? video.dataset.posterMobile : video.dataset.posterDesktop;
    configureBackdrop();
    afterPoster(() => { if (motionAllowed()) { attach(); play(); } else frame.dataset.filmState = 'poster'; });
   };
   const resize = new ResizeObserver(updateFit);
   const observer = new IntersectionObserver(entries => {
    visible = entries.some(entry => entry.isIntersecting);
    if (visible) { if (video.paused) play(); else scheduleBackdrop(); }
    else stopBackdrop();
   });
   const cleanup = () => { destroyed = true; removeBackdrop(); abort.abort(); resize.disconnect(); observer.disconnect(); video.pause(); films.delete(frame); };
   films.set(frame, cleanup);
   video.addEventListener('playing', reveal, { signal });
   video.addEventListener('pause', () => { stopBackdrop(); updateToggle(); if (manualPause) frame.dataset.filmState = 'paused'; }, { signal });
   video.addEventListener('play', updateToggle, { signal });
   video.addEventListener('seeked', () => { paintBackdrop(); scheduleBackdrop(); }, { signal });
   video.addEventListener('error', () => {
    stopBackdrop(); canvas?.classList.remove('is-ready');
    video.classList.remove('is-playing'); frame.dataset.filmState = 'poster';
    if (canvas) frame.dataset.filmBackdrop = 'poster';
    if (toggle) toggle.hidden = true;
   }, { signal });
   video.addEventListener('canplay', play, { signal });
   document.addEventListener('visibilitychange', () => { if (document.hidden) stopBackdrop(); else play(); }, { signal });
   window.addEventListener('pageshow', play, { signal });
   mobile.addEventListener('change', select, { signal });
   reduced.addEventListener('change', () => {
    motionOptIn = false;
    if (reduced.matches) { video.pause(); if (attached) frame.dataset.filmState = 'paused'; }
    else { attach(); play(); }
    updateToggle();
   }, { signal });
   toggle?.addEventListener('click', () => {
    if (!video.paused) { manualPause = true; video.pause(); }
    else { manualPause = false; motionOptIn = true; attach(); play(); }
    updateToggle();
   }, { signal });
   if (toggle) { toggle.hidden = false; updateToggle(); }
   resize.observe(frame); observer.observe(frame); select();
  });
 }
 initializeFilms();
 document.addEventListener('shopify:section:load', event => initializeFilms(event.target));
 document.addEventListener('shopify:section:unload', event => {
  for (const [frame, cleanup] of films) if (event.target.contains(frame)) cleanup();
 });
})();
document.querySelectorAll('.es-mobile-menu').forEach(menu=>{menu.addEventListener('toggle',()=>{if(menu.open&&matchMedia('(max-width:749px)').matches)menu.closest('.es-header')?.scrollIntoView({block:'start',behavior:'auto'});});menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{menu.open=false;}));menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});});

(() => {
  const script = document.currentScript, source = script?.dataset.deliveryData || (script?.src ? new URL('elmsett-delivery-postcodes.json', script.src).href : '');
  let table = null, count = 0;
  const load = () => table ||= fetch(source).then(response => { if (!response.ok) throw Error('Delivery data ' + response.status); return response.json(); }).then(data => { const days = new Map(); Object.entries(data.ranges).forEach(([range, list]) => list.split(' ').forEach(postcode => days.set(postcode, range.replace('-', '–')))); return {days, longer: new Set(data.longer.split(' '))}; }).catch(error => { table = null; throw error; });
  const answer = (postcode, data) => { if (!data) return 'Delivery is free Australia-wide. We’ll email you a tracking link once your rug ships.'; const days = data.days.get(postcode); if (days) return `Usually ${days} business days to ${postcode} once your rug ships.`; if (data.longer.has(postcode)) return `Delivery to ${postcode} is still free, but it may take longer. We’ll email you a tracking link once your rug ships.`; return `We couldn’t find postcode ${postcode}. Please check it and try again.`; };
  function init(root=document){ [...root.querySelectorAll('details')].filter(details=>details.querySelector('summary')?.textContent.trim()==='Delivery').forEach(details=>{ if(details.dataset.deliveryReady||(details.querySelector('.es-delivery-fixed')&&!details.querySelector('.es-po-region')))return; details.dataset.deliveryReady='true'; const id=`DeliveryPostcode-${++count}`, box=document.createElement('div'); box.className='es-delivery-estimate'; box.innerHTML=`<form class="es-delivery-estimate__form" novalidate><div class="es-delivery-estimate__field"><label for="${id}">Postcode</label><input id="${id}" name="postcode" inputmode="numeric" autocomplete="postal-code" maxlength="4" pattern="[0-9]{4}" required></div><button type="submit">Check delivery</button></form><p class="es-delivery-estimate__result" role="status" aria-live="polite" hidden></p>`; details.append(box); const form=box.querySelector('form'), input=box.querySelector('input'), result=box.querySelector('p'); details.addEventListener('toggle', ()=>{ if(details.open)load().catch(()=>{}); }); input.addEventListener('input', ()=>input.setCustomValidity('')); form.addEventListener('submit', async event=>{ event.preventDefault(); const postcode=input.value.trim(); input.setCustomValidity(/^\d{4}$/.test(postcode)?'':'Please enter a 4-digit postcode.'); if(!input.reportValidity()){ result.hidden=true; result.textContent=''; return; } const data=await load().catch(()=>null); result.hidden=false; result.textContent=answer(postcode, data); }); }); }
  init(); document.addEventListener('shopify:section:load', event=>init(event.target));
})();

/* Elmsett F-35b (Owner 2026-10-22, owner-calls.md "2026-10-22 F-35a"): on a product page the thumbnail row's arrows
   float over its ends (F-35a), so the thumbnail a shopper has just chosen could end under one. Once Dawn's gallery has
   finished its own scroll, a chosen thumbnail (tap, click, keyboard, or a swipe of the main photograph) that an arrow
   still covers is scrolled whole between the two arrows, onto one of the row's own snap points so the browser's
   snapping keeps it there. Dawn's files are untouched; this only reads the row and calls scrollTo on it. */
(() => {
  if (window.ElmsettThumbClear) return;
  window.ElmsettThumbClear = true;
  const GAP = 6;
  const HANDS = ['pointerdown', 'touchstart', 'wheel'];
  const ROW = '[data-template="product"] [id^="GalleryThumbnails"] .thumbnail-list';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const shown = (b) => b && !b.hidden && getComputedStyle(b).display !== 'none';
  function clear(item) {
    const list = item.closest('.thumbnail-list'), slider = item.closest('[id^="GalleryThumbnails"]');
    if (!list || !slider || !item.isConnected) return;
    const max = list.scrollWidth - list.clientWidth;
    if (max <= 1) return;
    const prev = slider.querySelector('.slider-button--prev'), next = slider.querySelector('.slider-button--next');
    const L = list.getBoundingClientRect(), it = (item.querySelector('.thumbnail') || item).getBoundingClientRect();
    const now = list.scrollLeft;
    // Room each arrow takes from the row, measured from the row's own edges. An arrow is away (Dawn disables it)
    // only at the row's start or end, so it counts everywhere else, wherever the row comes to rest.
    const padL = shown(prev) ? Math.max(0, prev.getBoundingClientRect().right - L.left + GAP) : 0;
    const padR = shown(next) ? Math.max(0, L.right - next.getBoundingClientRect().left + GAP) : 0;
    const cover = (s) => {
      const left = it.left - (s - now), right = it.right - (s - now);
      const a = s > 0.5 ? Math.max(0, L.left + padL - left) : Math.max(0, L.left - left);
      const b = s < max - 0.5 ? Math.max(0, right - (L.right - padR)) : Math.max(0, right - L.right);
      return a + b;
    };
    if (cover(now) < 0.5) return;
    // The row's snap points: each thumbnail's start, the row's start and its end.
    const snaps = [...list.querySelectorAll('.thumbnail-list__item')]
      .map((i) => Math.round(now + i.getBoundingClientRect().left - L.left))
      .concat([0, max]).filter((s) => s >= 0 && s <= max);
    let best = now, score = [cover(now), 0];
    for (const s of snaps) {
      const c = [cover(s), Math.abs(s - now)];
      if (c[0] < score[0] - 0.5 || (Math.abs(c[0] - score[0]) <= 0.5 && c[1] < score[1])) { best = s; score = c; }
    }
    if (Math.abs(best - now) >= 1) list.scrollTo({ left: best, behavior: reduce.matches ? 'auto' : 'smooth' });
  }
  // Wait until the row has stopped moving (Dawn's own scroll, smooth or not), then clear the chosen thumbnail.
  // The shopper's own hand wins: a touch, press, wheel or arrow click on the row while it waits cancels the move.
  function settle(item) {
    const list = item.closest('.thumbnail-list'), slider = item.closest('[id^="GalleryThumbnails"]');
    if (!list || !slider) return;
    // Dawn marks the same thumbnail again about half a second after a tap on a phone (its photograph slider reports
    // the change back); once the shopper has taken the row in hand, that repeat is not a new choice.
    if (list.esHandItem === item && Date.now() - list.esHandAt < 2000) return;
    if (list.esClearStop) list.esClearStop();
    const go = () => {
      clearTimeout(list.esClearTimer);
      list.esClearTimer = setTimeout(() => { stop(); clear(item); }, 140);
    };
    const hand = () => { list.esHandItem = item; list.esHandAt = Date.now(); stop(); };
    const stop = () => {
      clearTimeout(list.esClearTimer);
      list.removeEventListener('scroll', go);
      for (const type of HANDS) slider.removeEventListener(type, hand, true);
      list.esClearStop = null;
    };
    list.esClearStop = stop;
    list.addEventListener('scroll', go, { passive: true });
    for (const type of HANDS) slider.addEventListener(type, hand, { capture: true, passive: true });
    go();
  }
  new MutationObserver((records) => {
    for (const r of records) {
      const b = r.target;
      if (b.hasAttribute('aria-current') && b.closest(ROW)) settle(b.closest('.thumbnail-list__item') || b);
    }
  }).observe(document, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
  // Keyboard focus moving onto a thumbnail from another control; not a click (the chosen thumbnail is handled above)
  // and not the window getting focus back, which carries no previous control.
  document.addEventListener('focusin', (e) => {
    const t = e.target;
    if (t instanceof Element && e.relatedTarget && t.matches(':focus-visible') && t.closest(ROW)) {
      const item = t.closest('.thumbnail-list__item');
      if (item) settle(item);
    }
  });
})();
